/* eslint-disable no-shadow */
import React from 'react';
import { useSelector } from 'react-redux';

import { isOrganizer } from '../../../../../utils/events';

import PopOverMenu from '../../../../../components/PopOverMenu';

const TeamStandingsContentV2 = ({ showAddEditTeamPopUp, deleteTeamStanding }) => {
    const { event, teamStandings } = useSelector(({ eventProfile }) => {
        const { event, teamStandings } = eventProfile;
        return { event, teamStandings };
    });

    const handleTeamStandingAction = (action, standing) => {
        if (action.value === 'edit') {
            showAddEditTeamPopUp('edit', standing);
        } else if (action.value === 'delete') {
            deleteTeamStanding(event.data.id, standing.id);
        }
    };

    if (teamStandings !== null) {
        const menuItems = [
            { value: 'edit', label: 'Edit' },
            { value: 'delete', label: 'Delete' },
        ];

        return (
            <>
                <div className="row">
                    <div className="col-md-6 d-flex flex-row justify-content-between align-items-center">
                        <div className="col-md-5">
                            <h6 className="" data-testid="event-profile.team-standings.title">
                                Team Standings
                            </h6>
                        </div>
                        {isOrganizer(event.data) && (
                            <span onClick={() => showAddEditTeamPopUp('add')} className={`mt-4 col-md-6 d-flex flex-row justify-content-start align-items-center link clickable`} data-testid="event-profile.team-standings.add-team-btn">
                                <i className="fas fa-plus mr-2" />
                                <p className="m-0">Add Team</p>
                            </span>
                        )}
                    </div>
                    <div className="w-100">
                        <div className="w-100 m-0 row">
                            <div className="col-md-1">
                                <p data-testid="event-profile.team-standings.header-rank">Rank</p>
                            </div>
                            <div className="col-md-2">
                                <p data-testid="event-profile.team-standings.header-team-name">Team Name</p>
                            </div>
                            <div className="col-md-2">
                                <p data-testid="event-profile.team-standings.header-team-record">Team Record</p>
                            </div>
                            <div className="col-md-2">
                                <p data-testid="event-profile.team-standings.header-match-record">Match Record</p>
                            </div>
                            <div className="col-md-2 text-center">
                                <p data-testid="event-profile.team-standings.header-sets">Sets</p>
                            </div>
                            <div className="col-md-2 text-center">
                                <p data-testid="event-profile.team-standings.header-games">Games</p>
                            </div>
                            <div className="col-md-1" />
                        </div>
                    </div>
                </div>
                {teamStandings.sort((a, b) => (a.rank > b.rank ? 1 : -1)).map(standing => (
                    <div className="pl-2 row" key={standing.id} data-testid={`event-profile.team-standings.row-${standing.id}`}>
                        <div className="pt-4 pb-4 w-100 utr-card player-card d-flex flex-row justify-start align-items-center">
                            <div className="col-md-1">
                                <p data-testid={`event-profile.team-standings.row-${standing.id}.rank`}>{standing.rank}</p>
                            </div>
                            <div className="col-md-2">
                                <p data-testid={`event-profile.team-standings.row-${standing.id}.team-name`}>{standing.teamName}</p>
                            </div>
                            <div className="col-md-2">
                                <p data-testid={`event-profile.team-standings.row-${standing.id}.team-record`}>{standing.teamRecordWins} - {standing.teamRecordLosses}</p>
                            </div>
                            <div className="col-md-2">
                                <p data-testid={`event-profile.team-standings.row-${standing.id}.match-record`}>{standing.matchRecordWins} - {standing.matchRecordsLosses}</p>
                            </div>
                            <div className="col-md-2 text-center">
                                <p data-testid={`event-profile.team-standings.row-${standing.id}.sets`}>{standing.setsWins} - {standing.setsLosses}</p>
                            </div>
                            <div className="col-md-2 text-center">
                                <p data-testid={`event-profile.team-standings.row-${standing.id}.games`}>{standing.gamePercentage}%</p>
                            </div>
                            <div className="p-0 col-md-1">
                                {isOrganizer(event.data) && (
                                    <PopOverMenu
                                        menuItems={menuItems}
                                        onSelected={action => handleTeamStandingAction(action, standing)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </>
        );
    }
    return null;
};

export default TeamStandingsContentV2;
